'use client';

import { NotFound } from "app/components/pages/NotFound";


export default function NotFoundPage() {
  return <NotFound />;
}
